import React from 'react';

import { IonIcon } from '@ionic/react';

import clsx from 'clsx';

import ProgressBar from 'components/ProgressBar';
import Typography from 'components/Typography';

import './index.css';

interface IEmptyContent {
  icon?: string;
  text?: string;
  isRefetching?: boolean;
  withBorder?: boolean;
  withRadius?: boolean;
  children?: React.ReactNode;
}

const EmptyContent = ({
  icon,
  text = 'No Results',
  isRefetching = false,
  withBorder = true,
  withRadius = withBorder,
  children = null,
}: IEmptyContent) => {
  return (
    <div
      className={clsx('empty-content', {
        border: withBorder,
        radius: withRadius,
      })}
    >
      {icon && <IonIcon icon={icon} size={'large'} color={'medium-tint'} />}
      {text && (
        <Typography variant={'overline'} color={'medium-tint'}>
          {text}
        </Typography>
      )}

      {children}
      {isRefetching && <ProgressBar type={'indeterminate'} />}
    </div>
  );
};
export default EmptyContent;
